<template>
    <ValidationObserver ref="form" v-slot="{ passes, dirty }" tag="div" class="setting-block">
        <v-card>
            <v-toolbar class="elevation-0" color="blue lighten-5">
                <v-toolbar-title>Время работы</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn color="success"
                               small
                               fab
                               depressed
                               v-on="on"
                               :disabled="!dirty"
                               @click.prevent="save"
                        >
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                    </template>
                    <span>Сохранить изменения</span>
                </v-tooltip>
            </v-toolbar>
            <v-card-text class="pa-6">
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <ValidationProvider name="timezone"
                                            rules="required"
                                            v-slot="{ errors }"
                                            tag="div"
                        >
                            <v-autocomplete
                                v-model="timezone"
                                :items="timezones"
                                item-text="label"
                                item-value="value"
                                label="Часовой пояс"
                                :error-messages="errors"
                                outlined
                            />
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" class="pb-0">
                        <ValidationProvider name="open_time"
                                            rules="required"
                                            v-slot="{  }"
                                            tag="div"
                        >
                            <v-autocomplete
                                v-model="openTime"
                                :items="times"
                                label="Начало рабочего дня"
                                outlined
                            />
                        </ValidationProvider>
                    </v-col>
                    <v-col cols="12" sm="6" class="pb-0">
                        <ValidationProvider name="close_time"
                                            rules="required"
                                            v-slot="{  }"
                                            tag="div"
                        >
                            <v-autocomplete
                                v-model="closeTime"
                                :items="times"
                                label="Конец рабочего дня"
                                outlined
                            />
                        </ValidationProvider>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </ValidationObserver>
</template>

<script>
    import timezones from "../lib/timezones";
    import profileApi from '../api/profile.api';

    export default {
        name   : "SettingsTime",
        data() {
            return {
                times    : ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
                openTime : '00:00',
                closeTime: '24:00',
                timezone : 'Europe/Minsk',
                timezones
            }
        },
        created() {
            this.timezone = this.$auth.user().timezone;
            this.openTime = this.$auth.user().open_time;
            this.closeTime = this.$auth.user().close_time;
        },
        methods: {
            save() {
                this.$store.commit('setLoading', true);
                this.$refs.form.reset();

                profileApi.update({
                    timezone  : this.timezone,
                    open_time : this.openTime,
                    close_time: this.closeTime,
                }).then(({data}) => {
                    this.$auth.user(data.data);
                }).catch(({response}) => {
                    this.$refs.form.setErrors(response.data.errors);
                }).finally(() => {
                    this.$store.commit('setLoading', false);
                })
            }
        }
    }
</script>

<style scoped>

</style>
